module.exports = "mutation deleteCuratorPromocode($id: [ID!])\n{deleteCuratorPromocode(promocode_id: $id)}\n"